import React, { useState } from "react";
import { Icon, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CategoriesApi from "api/categories";

function ActionCell({ id, onDataUpdate }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const handleDelete = () => {
        const token = localStorage.getItem("token");
        CategoriesApi.DeleteMainCategory(token, id)
            .then(() => {
                onDataUpdate();
                setOpenDeleteDialog(false);
            })
            .catch((error) => {
                console.error("Failed to delete category:", error);
            });
    };

    return (
        <>
            <SoftBox display="flex" alignItems="center">
                <SoftTypography
                    variant="body1"
                    color="secondary"
                    sx={{ cursor: "pointer", lineHeight: 0, mr: 2 }}
                    onClick={() => navigate(`/gestion-de-stock/main-categories/modifier-categorie/${id}`)}
                >
                    <Icon>edit</Icon>
                </SoftTypography>
                <SoftTypography
                    variant="body1"
                    color="error"
                    sx={{ cursor: "pointer", lineHeight: 0 }}
                    onClick={() => setOpenDeleteDialog(true)}
                >
                    <Icon>delete</Icon>
                </SoftTypography>
            </SoftBox>

            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>{t("Confirmation de suppression")}</DialogTitle>
                <DialogContent>
                    <SoftTypography variant="body2" color="text">
                        {t("Êtes-vous sûr de vouloir supprimer cette catégorie ?")}
                    </SoftTypography>
                </DialogContent>
                <DialogActions>
                    <SoftButton variant="gradient" color="light" onClick={() => setOpenDeleteDialog(false)}>
                        {t("Annuler")}
                    </SoftButton>
                    <SoftButton variant="gradient" color="error" onClick={handleDelete}>
                        {t("Supprimer")}
                    </SoftButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ActionCell;
